<script setup lang="ts">
defineProps<{
  minimized?: boolean;
  minimize?: () => void;
  isFullscreen?: boolean;
  toggleFullscreen?: () => void;
  closable?: boolean;
  fullscreenable?: boolean;
  close?: () => void;
  minimizable?: boolean;
  startDrag?: (event: MouseEvent) => void;
}>();
</script>

<template>
  <div
    v-if="!minimized"
    class="tw:absolute tw:!w-full tw:h-6 tw:flex tw:!pt-1 tw:justify-end tw:cursor-move tw:font-medium tw:text-white"
    :style="{
      paddingRight: isFullscreen ? '1rem' : '0.5rem',
    }"
    @mousedown="startDrag"
    @dblclick="toggleFullscreen"
  >
    <div
      class="tw:flex tw:gap-4 tw:shadow-lg tw:transition-all tw:bg-gray-200/50 tw:duration-200 tw:rounded-lg tw:px-4 tw:py-2"
    >
      <button
        v-if="minimizable"
        icon
        size="small"
        class="tw:w-5 tw:h-5 tw:bg-surface tw:bg-opacity-20 tw:text-on-surface tw:cursor-pointer tw:flex tw:items-center tw:justify-center tw:text-sm tw:font-bold tw:transition-colors tw:duration-200"
        @click="minimize"
        @mousedown.stop
      >
        <v-icon
          color="blue-grey-darken-1"
          size="small"
          >mdi-minus</v-icon
        >
      </button>
      <button
        v-if="fullscreenable"
        icon
        size="small"
        class="tw:w-5 tw:h-5 tw:bg-surface tw:bg-opacity-20 tw:text-on-surface tw:cursor-pointer tw:flex tw:items-center tw:justify-center tw:text-sm tw:font-bold tw:transition-colors tw:duration-200"
        @click="toggleFullscreen"
        @mousedown.stop
      >
        <v-icon
          color="blue-grey-darken-1"
          size="small"
          >{{ isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen" }}</v-icon
        >
      </button>
      <button
        v-if="closable"
        icon
        size="small"
        class="tw:w-5 tw:h-5 tw:bg-surface tw:bg-opacity-20 tw:text-on-surface tw:cursor-pointer tw:flex tw:items-center tw:justify-center tw:text-sm tw:font-bold tw:transition-colors tw:duration-200"
        @click="close"
        @mousedown.stop
      >
        <v-icon
          color="blue-grey-darken-1"
          size="small"
          >mdi-close</v-icon
        >
      </button>
    </div>
  </div>
</template>
